(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4366],{

/***/ 9726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgVoli = function SvgVoli(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 56 18"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#000",
    d: "M3.382.242c1.081 0 2.033.712 2.339 1.749l3.144 10.665a.097.097 0 0 0 .186 0l3.144-10.664a2.44 2.44 0 1 1 4.657 1.458l-3.759 11.33a4.346 4.346 0 0 1-8.249.005L1.07 3.451A2.438 2.438 0 0 1 3.382.24M35.42 9c0 5.83-3.74 9-8.473 9-4.782 0-8.486-3.206-8.498-9 .012-5.83 3.716-9 8.498-9 4.733 0 8.474 3.17 8.474 9M23.195 9c0 3.218 1.332 4.972 3.753 4.984 2.397-.012 3.74-1.766 3.728-4.984.012-3.23-1.331-4.984-3.728-4.984-2.421 0-3.753 1.754-3.753 4.984M43.543 17.758a5.87 5.87 0 0 1-5.87-5.871V2.542a2.3 2.3 0 0 1 4.6 0v7.92a3.57 3.57 0 0 0 3.57 3.57h1.709a1.863 1.863 0 1 1 0 3.726zM53.7.242a2.3 2.3 0 0 1 2.3 2.3v12.916a2.3 2.3 0 0 1-4.6 0V2.542a2.3 2.3 0 0 1 2.3-2.3"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgVoli);

/***/ }),

/***/ 9238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 108 55"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#8A62F7",
    fillOpacity: 0.8,
    d: "M9 9.862c4.97-4.97 13.03-4.97 18 0L44.999 27.86c4.97 4.97 4.97 13.029 0 18-4.97 4.97-13.03 4.97-18 0L9 27.86c-4.97-4.97-4.97-13.029 0-18M45 9.862c4.97-4.97 13.03-4.97 18 0L80.999 27.86c4.97 4.97 4.97 13.029 0 18-4.97 4.97-13.03 4.97-18 0L45 27.86c-4.97-4.97-4.97-13.029 0-18"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#612DF5",
    fillOpacity: 0.9,
    d: "M63 9.862c-4.97-4.97-13.03-4.97-18 0L27.001 27.86c-4.97 4.97-4.97 13.029 0 18 4.97 4.97 13.03 4.97 18 0L63 27.86c4.97-4.97 4.97-13.029 0-18M99 9.862c-4.97-4.97-13.03-4.97-18 0L63.001 27.86c-4.97 4.97-4.97 13.029 0 18 4.97 4.97 13.03 4.97 18 0L99 27.86c4.97-4.97 4.97-13.029 0-18"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgLogo);

/***/ }),

/***/ 5428:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/labs/shorts",
      function () {
        return __webpack_require__(6947);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5902);
/* harmony import */ var _styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _public_logo_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9238);
/* harmony import */ var _public_VOLI_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9726);






var scriptList = [
    "나야, 들기름",
    "저는 채소의 익힘 정도를 굉장히 중요시 여기거덩요",
    "탈락입니다! 너무짜요!",
    "좋았어, 진행시켜",
    "니 내 누군지 아니?",
    "내 이름은 코난, 탐정이죠",
    "지금까지 이런 맛은 없었다",
    "제 말을 전적으로 믿으셔야 합니다, 어머니",
    "후라이까지마라",
    "내가 왕이 될 상인가?",
    "헛소리하지마 인마!",
    "살아있네",
    "먹지마세요, 피부에 양보하세요",
    "사랑은 돌아오는 거야!",
    "야 창식아",
    "라면먹고 갈래요?",
    "누가 기침소리를 내었어?",
    "오늘 밤은 이 방이 최전방이야",
    "사딸라",
    "내 가치를 네가 정하지 마",
    "너나 잘하세요",
    "멋지다 연진아",
    "으에에~이쁜누나다",
    "좋았어, 진행시켜",
    "우리가 돈이 없지, 가오가 없냐?",
    "넌 나에게 모욕감을 줬어",
    "묻고 더블로 가!",
    "오겡끼데스까", 
];
var Shorts = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(Math.floor(Math.random() * scriptList.length)), scriptIndex = ref[0], setScriptIndex = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "AI 성대모사 쇼츠 제작"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().header),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inner),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            href:  false ? 0 : "".concat("https://voli.ai", "/labs/shorts"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_logo_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    height: 20.14
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_VOLI_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    height: 15,
                                    className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().voli)
                                }),
                                "x ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Shorts"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href:  false ? 0 : "https://voli.ai",
                            className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().voli_link),
                            children: "볼리 바로가기"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrap),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().main),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/labs/shorts/background.webp",
                                alt: "",
                                height: 224,
                                "aria-hidden": true,
                                className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().background_animation)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/labs/shorts/main.webp",
                                alt: "",
                                width: 255,
                                height: 255,
                                className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().character)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().script),
                                children: scriptList[scriptIndex]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label),
                                        children: "AI가 목소리를 바꿔줘요!"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        children: "AI 성대모사"
                                    }),
                                    " 쇼츠"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bottom),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "/labs/shorts/start",
                                        className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().start_link),
                                        children: "시작하기"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: (_styles_labs_shorts_module_scss__WEBPACK_IMPORTED_MODULE_3___default().text),
                                        children: [
                                            "성대모사가 이렇게 쉬웠다고?",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "AI로 조회수 대박나는 성대모사 쇼츠 만들어봐!"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Shorts);


/***/ }),

/***/ 5902:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pc":"shorts_pc__R0r9X","mobile":"shorts_mobile__9b7Ch","hide":"shorts_hide__JdGns","header":"shorts_header__o_uno","inner":"shorts_inner__v2Vkz","voli":"shorts_voli__0Dhpv","voli_link":"shorts_voli_link__cBaeS","back_btn":"shorts_back_btn__lWfiH","filming":"shorts_filming__L9Wb4","download":"shorts_download__s099L","wrap":"shorts_wrap___g3O1","container":"shorts_container__G927K","background_animation":"shorts_background_animation__TX7yC","flow":"shorts_flow__Ei3qy","main":"shorts_main__93eA9","script":"shorts_script__Pw_nG","character":"shorts_character__He3Sq","label":"shorts_label__7kEmJ","bottom":"shorts_bottom__w9LyO","start_link":"shorts_start_link__J6_lL","text":"shorts_text__sAmZp","select_voice":"shorts_select_voice__HqPoi","title_area":"shorts_title_area__kq4SP","title":"shorts_title__F75iI","select_area":"shorts_select_area__mcI2o","voice_list":"shorts_voice_list__bH23n","voice_item":"shorts_voice_item__J4Hzp","active":"shorts_active__G5DN5","img_placeholder":"shorts_img_placeholder__i3Ewo","voice_area":"shorts_voice_area__4MGRI","name":"shorts_name__PqV2I","play_btn":"shorts_play_btn__unQUI","start_btn":"shorts_start_btn__2_zHt","privacy_btn":"shorts_privacy_btn__F_Adx","background":"shorts_background__LyZP1","privacy_modal":"shorts_privacy_modal__ndp7J","guide":"shorts_guide__4Q4SV","guide_header":"shorts_guide_header__9r8bI","step":"shorts_step__o4qcG","content_area":"shorts_content_area__k0eJB","confirm_btn":"shorts_confirm_btn__Otidi","video_area":"shorts_video_area___oXTA","control_area":"shorts_control_area__pwrzI","btn_area":"shorts_btn_area__uB80J","complete_text":"shorts_complete_text__W8_w8","re_record_btn":"shorts_re_record_btn__mVK2n","home_link":"shorts_home_link__WkIM7","convert_btn":"shorts_convert_btn__kYHmx","make":"shorts_make__AKKiV","guide_text":"shorts_guide_text__bQBcg","complete":"shorts_complete__oSB5E","processing":"shorts_processing__066CK","loading":"shorts_loading__x6Q1A","powered":"shorts_powered__vK1kG","logo":"shorts_logo__kQW7o","description":"shorts_description__xefIW","feature":"shorts_feature__cE0AO","ad":"shorts_ad__AtY3n","highlight":"shorts_highlight__KKKFN","background_confirm":"shorts_background_confirm__PfKkY","login_confirm":"shorts_login_confirm__3sKlF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3343,9774,2888,179], function() { return __webpack_exec__(5428); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);